import { render } from "./PublicationView.vue?vue&type=template&id=2c748d97&scoped=true"
import script from "./PublicationView.vue?vue&type=script&lang=js"
export * from "./PublicationView.vue?vue&type=script&lang=js"

import "./PublicationView.vue?vue&type=style&index=0&id=2c748d97&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c748d97"]])

export default __exports__